import { useState } from "react";
import { apiPaths } from "../../../service/apiPaths";
import ApiService from "../../../service/ApiService";
import toast from "react-hot-toast";

const useEditArticle = () =>{

   const[loading , setLoading] = useState(false)

   const[courses , setCourses] = useState<any[]>([]);
   const[standards , setStandard] = useState<any[]>([]) ;
   const[categories , setCategory] = useState<any[]>([])
    const fetchCoursesAndLanguages = async () => {
        try {
          setLoading(true);
          const [
            coursesResponse,
            categoryResponse,
            standardResponse,
          ] = await Promise.all([
            ApiService({ method: "GET", endpoint: apiPaths.getCourse }),
            ApiService({ method: "GET", endpoint: apiPaths.getAllCategories }),
           
            ApiService({ method: "GET", endpoint: apiPaths.getStandard }),
          ]);
    
          setCourses(coursesResponse);
          setCategory(categoryResponse)
         
          setStandard(standardResponse);
        } catch (error) {
          console.error("Error fetching courses and languages:", error);
          toast.error("Failed to fetch courses or languages."); // Show error toast
        } finally {
          setLoading(false);
        }
      }

      return {courses , standards , categories , loading , fetchCoursesAndLanguages}

}

export default useEditArticle